export const REPO_TYPE = 'source.code.link';
export const LINK_TYPE = 'project.shortcut.default.link';
export const INVALID_URL = 'INVALID_URL';
